import { EBookFormActions } from "../constants/book-form";
import { IAction } from "../interfaces/action.interface";

export interface IBookFormReducer {
    isCreated: boolean,
    isError: boolean,
}

const initialState:IBookFormReducer = {
    isCreated: false,
    isError: false,
};

const bookFormReducer = (state:IBookFormReducer = initialState, action:IAction) => {
    switch(action.type) {
        default: {
            return state;  
        }
    }
};

export default bookFormReducer; 